import {Controller} from 'stimulus';

export default class extends Controller {
  static targets = ['links', 'loader'];

  initialize() {
    if (this.hasLinksTarget) {
      [...this.linksTarget.children].forEach(($link) => {
        $link.addEventListener('click', (e) => {
          this.handleLinkClick(e);
        });
      });
    }
  }

  handleLinkClick(event) {
    this.hasLoaderTarget && this.loaderTarget.classList.add('show');
  }
}
